import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  EVENT,
  ICONS_CHANNEL,
  MAIN_FILTER
} from "../../constants/EventConstants";

Vue.use(Vuetify);

@Component({
  name: "EventData"
})
export default class EventData extends Vue {
  @Prop({ default: "" })
  private timelineEventType!: string;
  @Prop({ default: "" })
  private title!: string;
  @Prop({ default: "" })
  private description!: string;
  @Prop({ default: undefined })
  private details!: {};
  @Prop({ default: "" })
  private emailCreated!: string;
  @Prop({ default: "" })
  private emailChanged!: string;
  @Prop({ default: { name: "", document: "" } })
  private userData!: { name: string; document: string };
  @Prop({ default: "" })
  private serviceName!: string;
  @Prop({ default: { name: "", id: "" } })
  private rule!: { name: string; id: string };

  iconsChannel = ICONS_CHANNEL;
  SERVICE = MAIN_FILTER.SERVICE;
  NOTIFICATION = MAIN_FILTER.NOTIFICATION;
  DOCUMENT = MAIN_FILTER.DOCUMENT;
  EVENT_FIELDS = EVENT.FIELDS;
  isComplexDetails = false;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  complexData: Record<string, any>[] = [];

  mounted() {
    console.log("rule ", this.rule);
    const detailsAux = JSON.parse(JSON.stringify(this.details));
    this.isComplexDetails = detailsAux.Complex || detailsAux.complex;

    if (this.isComplexDetails) {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      delete (detailsAux as any)["Complex"];
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      delete (detailsAux as any)["complex"];

      Object.keys(detailsAux).forEach((key: string) => {
        this.complexData.push({
          title: key,
          /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
          value: (detailsAux as any)[key]
        });
      });
    }
  }
}
